import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_14 = { class: "form-contents" };
const _hoisted_15 = { class: "row" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_18 = { class: "clearfix" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_20 = { class: "bottom10" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_22 = { class: "invalid-feedback" };
const _hoisted_23 = { class: "bottom10" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tScope *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_25 = { class: "invalid-feedback" };
const _hoisted_26 = { class: "bottom10" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Time Window (minutes) "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-question-circle-o",
        "aria-hidden": "true",
        title: "This is the time period over which the defined alarms will be grouped as a single event. The period is measured from the last alarm raise time. A new event will be created if an alarm is raised after this time."
    })
], -1 /* HOISTED */);
const _hoisted_28 = { class: "invalid-feedback" };
const _hoisted_29 = { class: "checkbox-wrapper" };
const _hoisted_30 = { class: "checkbox-wrapper" };
const _hoisted_31 = { class: "checkbox-wrapper" };
const _hoisted_32 = { class: "checkbox-wrapper" };
const _hoisted_33 = { class: "ms-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Minimum alarm duration before sending notification (minutes) "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-question-circle-o",
        "aria-hidden": "true",
        title: "The minimum duration for which the first alarm must be raised before sending notifications. If the alarm duration is less than this value, no notification will be sent. A value of '0' means the notification will be sent immediately."
    })
], -1 /* HOISTED */);
const _hoisted_35 = { class: "invalid-feedback" };
const _hoisted_36 = { class: "checkbox-wrapper" };
const _hoisted_37 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tGroup Alarm Definition(s)\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_39 = { class: "d-flex mb-2" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, "Reset", -1 /* HOISTED */);
const _hoisted_41 = { class: "d-flex mb-1" };
const _hoisted_42 = { key: 0 };
const _hoisted_43 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "font-weight-normal" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, "Reset", -1 /* HOISTED */);
const _hoisted_47 = { class: "d-flex justify-content-between" };
const _hoisted_48 = { class: "d-flex" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, "Select All", -1 /* HOISTED */);
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, "Unselect All", -1 /* HOISTED */);
const _hoisted_51 = { class: "d-flex align-items-end" };
const _hoisted_52 = ["disabled"];
const _hoisted_53 = ["disabled"];
const _hoisted_54 = {
    class: "list-filter",
    style: { "height": "415px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_55 = { class: "list-options" };
const _hoisted_56 = ["title", "onClick"];
const _hoisted_57 = { style: { "font": "700", "font-size": "16px" } };
const _hoisted_58 = { class: "col-xs-12 col-sm-12 col-md-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_ContactsVue = _resolveComponent("ContactsVue");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isEventTypeArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing event type name...'), 3 /* TEXT, CLASS */)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _ctx.archive
                    }, {
                        default: _withCtx(() => [
                            _hoisted_8,
                            _hoisted_9
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewEventType && !_ctx.isEventTypeArchived]
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _ctx.restore
                    }, {
                        default: _withCtx(() => [
                            _hoisted_10,
                            _hoisted_11
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewEventType && _ctx.isEventTypeArchived]
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [
                            _hoisted_12,
                            _hoisted_13
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _hoisted_21,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                maxlength: "150",
                                                modelValue: _ctx.eventType.eventTypeName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.eventType.eventTypeName) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a event name.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_23, [
                                            _hoisted_24,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.scopeVal, {
                                                modelValue: _ctx.eventScope,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.eventScope) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: _ctx.selectPlaceholder,
                                                options: _ctx.eventScopes,
                                                showLabels: false,
                                                class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.scope }
                                            }), {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_25, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select an event scope\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.scope]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_26, [
                                            _hoisted_27,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.timeWindowVal, {
                                                modelValue: _ctx.eventType.timeWindowMinutes,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.eventType.timeWindowMinutes) = $event)),
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                max: "1440",
                                                class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.timeWindow }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a value between 0 and 1,440 Minutes.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.timeWindow]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.enabled,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.eventType.enabled) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tEnabled\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_30, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendEmail,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.eventType.sendEmail) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend Email\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendSms,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.eventType.sendSms) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend SMS\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ])), [
                                            [_directive_cloud_only]
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_32, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendNotificationsOnFirstAlarm,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.eventType.sendNotificationsOnFirstAlarm) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend notifications when first alarm is raised\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_33, [
                                            _hoisted_34,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.minEventDurationVal, {
                                                modelValue: _ctx.eventType.minEventDuration,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.eventType.minEventDuration) = $event)),
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                max: "1440",
                                                class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.minEventDuration },
                                                disabled: !_ctx.eventType.sendNotificationsOnFirstAlarm
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "disabled"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_35, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a value between 0 and 60 Minutes.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.timeWindow]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendNotificationsAfterTimeWindow,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.eventType.sendNotificationsAfterTimeWindow) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend notifications when time window ends\r\n\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_37, [
                                        _hoisted_38,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_39, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.alarmType,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.alarmType) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: "Any alarm type",
                                                options: _ctx.alarmTypeOptionsVisible,
                                                showLabels: false
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.alarmTypeId = null))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_40
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_41, [
                                            _createVNode(_component_multiselect, {
                                                ref: "alarmSeverityOptions",
                                                id: "alarmSeverityFilter",
                                                name: "alarmSeverityOptions",
                                                options: _ctx.alarmSeverities,
                                                multiple: true,
                                                showLabels: false,
                                                preserveSearch: true,
                                                closeOnSelect: false,
                                                placeholder: "",
                                                "track-by": "value",
                                                label: "text",
                                                class: "multiselect-small",
                                                disabled: _ctx.working
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                placeholder: _withCtx(() => [
                                                    (!_ctx.numberOfSeletedAlarmSeverities)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                selection: _withCtx(({ search, isOpen }) => [
                                                    (_ctx.numberOfSeletedAlarmSeverities && !isOpen)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.alarmSeverityOptionText), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                option: _withCtx((props) => [
                                                    _createElementVNode("div", {
                                                        onClick: _withModifiers(($event) => (_ctx.selectSeverity(props.option)), ["stop"])
                                                    }, [
                                                        (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                                            id: 'severity-' + props.option.value,
                                                            checked: props.option.selected,
                                                            key: _ctx.getAlarmSeverityFilter(props.option)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("label", _hoisted_45, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                                                    ], 8 /* PROPS */, _hoisted_44)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["options", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _cache[11] || (_cache[11] = ($event) => ((_ctx.alarmSeverities.forEach(item => item.selected = true))))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_46
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_47, [
                                            _createElementVNode("div", _hoisted_48, [
                                                _createVNode(_component_b_button, {
                                                    class: "me-2",
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.selectAllAlarmDefinitions
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_49
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_button, {
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.unselectAllAlarmDefinitions
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_50
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedAlarmsCount()), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input ms-3",
                                                    style: { "margin-bottom": "11px" },
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.showOnlyAlarmsSelected) = $event)),
                                                    disabled: (_ctx.selectedAlarmsCount() == 0)
                                                }, null, 8 /* PROPS */, _hoisted_52), [
                                                    [_vModelCheckbox, _ctx.showOnlyAlarmsSelected]
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    disabled: _ctx.selectedAlarmsCount() == 0
                                                }, " Show only selected", 8 /* PROPS */, _hoisted_53)
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("div", _hoisted_55, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarmDefinitionOptionsVisible, (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(['list-option', _ctx.isAlarmSelected(item) ? 'selected-option' : '', _ctx.isAlarmInUse(item) ? 'in-use-option' : '']),
                                                        title: _ctx.getAlarmDefnitionTitle(item),
                                                        onClick: _withModifiers((event) => _ctx.selectAlarm(item, event), ["prevent"]),
                                                        style: { "text-align": "left", "padding": "5px" }
                                                    }, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("span", _hoisted_57, _toDisplayString(item.text), 1 /* TEXT */)
                                                        ])
                                                    ], 10 /* CLASS, PROPS */, _hoisted_56));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_58, [
                                    _createVNode(_component_ContactsVue, {
                                        companyId: _ctx.companyId,
                                        filterOnlyContactsWithEmail: false,
                                        isReport: false,
                                        contactIds: _ctx.eventType.contactIds,
                                        "onUpdate:contactIds": _cache[13] || (_cache[13] = ($event) => ((_ctx.eventType.contactIds) = $event)),
                                        contactGroupIds: _ctx.eventType.contactGroupIds,
                                        "onUpdate:contactGroupIds": _cache[14] || (_cache[14] = ($event) => ((_ctx.eventType.contactGroupIds) = $event))
                                    }, null, 8 /* PROPS */, ["companyId", "contactIds", "contactGroupIds"])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
